module.exports = __webpack_public_path__ + "static/media/info-domain.f8644dfa.svg";